import { BaseType } from '../../base/base-type';
import { StatusReasonTypeId } from '../../enum/shared/status-reason-type-id';

export class StatusReasonType extends BaseType {
  public declare id: StatusReasonTypeId;
}
